function buildRequestBody(payload) {
  let body = {
    data: {
      type: "addresses",
      attributes: payload.attributes,
      relationships: {
        district: {
          data: {
            type: "districts",
            id: payload.districtID
          }
        }
      }
    }
  };

  body.data.relationships[payload.addressable.type] = {
    data: [payload.addressable]
  };

  return body;
}

function buildUpdateRequestBody(payload) {
  let { id, name, complement, reference } = payload;

  return {
    data: {
      type: "addresses",
      id,
      attributes: {
        name,
        complement,
        reference
      }
    }
  };
}

export default {
  buildRequestBody,
  buildUpdateRequestBody
};



// WEBPACK FOOTER //
// ./src/api/helpers/addresses.js